/*
    Ruta de la api de catalogo
*/
export default {
    APP_CATALOGOS: '/api/Catalogos',
    URL_AMBITO : '/api/Ambito',
    URL_EJES : '/api/Ejes',
    URL_OBJETIVOS_PLAN_NACIONAL: '/api/ObjetivosPlanNacionalEstrategias',
    URL_OBJETIVOS_PLAN_ESTATAL_BYIDEJEPOLITICOGRUPO: '/api/ObjetivosPlanEstatal/ByIdEjePoliticaGrupo',
    URL_EJE_POLITICAS_BYIDEJE:'/api/EjePoliticas/ByIdEje',
    URL_EJE_POLITICAS_GRUPOS_BYIDEJEPOLITICA:'/api/EjePoliticaGrupos/ByIdEjePolitica',
    URL_PROGRAMA_SECTORIAL:'/api/ProgramaSectorial',
    URL_INDICADORES: '/api/Indicadores',
    URL_FORMULAS: '/api/Formulas',
    URL_FRECUENCIA: '/api/Frecuencia',
    URL_TIPO_INDICADOR: '/api/TipoIndicador',
    URL_DIMENCION: '/api/DimensionIndicador',
    URL_UNIDAD_MEDIDA: '/api/UnidadMedida',
    URL_COMPORTAMIENTO: '/api/ComportamientoIndicador',
    URL_TIPO_VALOR_META: '/api/TipoValorMeta',
    URL_PROGRAMA_PRESUPUESTARIO: '/api/ProgramaPresupuestario',
    URL_MODALIDAD: '/api/Modalidad',
    URL_UNIDAD_RESPONSABLE: '/api/UnidadResponsable',
    URL_AREA_OPERATIVA: '/api/UnidadResponsableOperativa',
    URL_ODS: '/api/ObjetivosMilenio',
    URL_METAS_BYIDODS: '/api/MetasMilenio/ById',

}